const ResponseStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
};

export default ResponseStatus;